import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type ControlGroupProps = {
    title: string;
    children?: ReactNode;
}

export function ControlGroup({
    title,
    children,
}: ControlGroupProps) {
    return (
        <Stack direction="column" spacing={1}>
            <Typography
                sx={{
                    fontSize: "14px",
                    fontWeight: 700,
                    borderTop: '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    py: '3px',
                    pl: '3px',
                    mb: '8px',
                    backgroundColor: '#ebebeb',
                }}
            >
                · {title}
            </Typography>
            {children}
        </Stack>
    )
}